export default {
	headerSearch: {
  "preferences": "Thème et langue",
  "collapsed": "Rechercher…",
  "open": "Rechercher des personnes et des guides",
  "placeholder": "Consultant, médium ou guide…",
  "hint": "Saisissez au moins 2 caractères.",
  "empty": "Aucun résultat trouvé.",
  "error": "Certains résultats n’ont pas pu être chargés. Réessayez.",
  "limit": "Jusqu’à 5 résultats par catégorie. Précisez le nom pour en trouver davantage.",
  "primaryMedium": "Médium principal : {name}",
  "noPrimary": "Aucun médium principal",
  "consulente": "Consultant",
  "medium": "Médium",
  "guide": "Guide"
},
	active: "Actif",
	inactive: "Inactif",
	status: "Statut",
	actions: "Actions",
	notFinished: "Non terminé",
	save: "Enregistrer",
	cancel: "Annuler",
	edit: "Modifier",
	delete: "Supprimer",
	create: "Créer",
	update: "Mettre à jour",
	add: "Ajouter",
	change: "Modifier",
	remove: "Retirer",
	typeToSearch: "Tapez pour rechercher",
	years: "ans",
	search: "Rechercher",
	searchField: "Recherche",
	filter: "Filtrer",
	loading: "Chargement...",
	back: "Retour",
	confirmDelete: "Confirmer la suppression",
	createdAt: "Créé le",
	notSpecified: "Non spécifié",
	optional: "facultatif",
	unknown: "Inconnu",
	unnamed: "Sans nom",
	view: "Voir",
	details: "Détails",
	close: "Fermer",
	yes: "Oui",
	no: "Non",
	invalidValue: "Valeur invalide",
	activate: "Activer",
	all: "Tous",
	complete: "Terminer",
	confirm: "Confirmer",
	createdBy: "Créé par",
	deactivate: "Désactiver",
	description: "Description",
	endedAt: "Terminé le",
	error: "Erreur lors de l'opération",
	errorLoading: "Erreur lors du chargement des données",
	errorSaving: "Erreur lors de l'enregistrement des données",
	lastUpdate: "Dernière mise à jour",
	loadMore: "Charger plus",
	next: "Suivant",
	notes: "Notes",
	print: "Imprimer",
	required: "Champ obligatoire",
	saved: "Enregistré avec succès",
	showActiveOnly: "Afficher uniquement les actifs",
	showLess: "Afficher moins",
	showMore: "Afficher plus",
	since: "Depuis",
	start: "Commencer",
	timestamps: "Dates système",
	viewDetails: "Voir les détails",
};
